import '@stimulus/polyfills'
import { Application } from '@stimulus/core'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

const application = Application.singleton || (Application.singleton = Application.start())

const context = require.context('../controllers', true, /.js$/)
application.load(definitionsFromContext(context))
